/**
 * Shared utility functions for BookList components
 * Pure functions only - constants are in constants.ts
 */

/**
 * Format author array for display
 */
export function formatAuthors(authors: string[] | string | null | undefined): string {
    if (!authors) return 'Desconocido'
    if (Array.isArray(authors)) return authors.join(', ') || 'Desconocido'
    return authors || 'Desconocido'
}

/**
 * Format category array for display
 */
export function formatCategories(categories: string[] | string | null | undefined): string {
    if (!categories) return '-'
    if (Array.isArray(categories)) return categories.join(', ') || '-'
    return categories || '-'
}

/**
 * Import check status type
 */
export type CheckStatus = 'exact' | 'partial' | 'new'

/**
 * Get check status icon for import preview
 */
export function getCheckStatusIcon(status: CheckStatus): string {
    switch (status) {
        case 'exact':
            return '❗' // Red exclamation for exact match
        case 'partial':
            return '❓' // Orange question for title match
        default:
            return '✨' // Sparkles for new
    }
}
